import { Component, Input, inject } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FormGroupComponent, InputComponent } from '@tecalisdev/infinity';

import { LanguageService } from '../../../../core/services/language.service';
import { resolveWorkflowLocaleText } from '../../../utils/workflow-locale-text.util';
import { ITextLocaleMap } from '../../../models/workflows.models';

@Component({
	selector: 'app-form-step-readonly-view',
	imports: [FormGroupComponent, InputComponent],
	templateUrl: './form-step-readonly-view.component.html',
	styleUrl: './form-step-readonly-view.component.scss',
})
export class FormStepReadonlyViewComponent {
	private languageService = inject(LanguageService);

	@Input({ required: true }) form!: FormGroup;

	public get fieldsArray(): FormArray {
		return this.form.get('fields') as FormArray;
	}

	/** Muestra pauta o descripción en el idioma activo del operador (soporta string legacy o mapa). */
	public resolveStepText(field: 'step_name' | 'step_description'): string {
		const localeTextValue = this.form.get(field)?.value as string | ITextLocaleMap | null | undefined;
		return resolveWorkflowLocaleText(localeTextValue, this.languageService.getLanguage());
	}

	public resolveFieldLabel(index: number): string {
		const title = this.resolveFieldTitle(index);
		return this.isFieldRequired(index) ? `${title}*` : title;
	}

	public isFieldRequired(index: number): boolean {
		const validators = (this.fieldsArray.at(index)?.get('validators')?.value as string[]) ?? [];
		return validators.includes('required');
	}

	private resolveFieldTitle(index: number): string {
		const titleValue = this.fieldsArray.at(index)?.get('title')?.value as string | ITextLocaleMap | null | undefined;
		const resolved = resolveWorkflowLocaleText(titleValue, this.languageService.getLanguage());
		const name = String(this.fieldsArray.at(index)?.get('name')?.value ?? '');
		return resolved || name;
	}
}
